type EnvType = {
  VITE_APP_API_HOST: string;
  VITE_APP_INTERCOM_APP_ID: string;
  VITE_APP_CHATWOOT_URL: string;
  VITE_APP_CHATWOOT_SDK_PATH: string;
  VITE_APP_CHATWOOT_TOKEN_UZ: string;
  VITE_APP_CHATWOOT_TOKEN_KE: string;
  VITE_APP_CHATWOOT_TOKEN_SI: string;
  VITE_APP_CHATWOOT_TOKEN_KZ: string;
  VITE_APP_CHATWOOT_TOKEN_IN: string;
  VITE_APP_CHATWOOT_TOKEN_TR: string;
  VITE_APP_CHATWOOT_TOKEN_MC: string;
  VITE_APP_CHATWOOT_TOKEN_BN: string;
  VITE_APP_CHATWOOT_TOKEN_AZ: string;
  VITE_APP_CHATWOOT_TOKEN_NP: string;
  VITE_APP_CHATWOOT_TOKEN_VN: string;
  VITE_APP_CHATWOOT_TOKEN_KR: string;
  VITE_APP_CHATWOOT_TOKEN_PK: string;
  VITE_APP_CHATWOOT_TOKEN: string;
  VITE_APP_CHATWOOT_TOKEN_BANGER: string;
  VITE_APP_CHATWOOT_TOKEN_BANGER_BN: string;
  VITE_APP_CHATWOOT_TOKEN_BANGER_IN: string;
  VITE_APP_CHATWOOT_TOKEN_BANGER_FR: string;
  VITE_APP_CHATWOOT_TOKEN_BANGER_GB: string;
  VITE_APP_CHATWOOT_TOKEN_BANGER_VN: string;
  VITE_APP_CHATWOOT_HMAC_UZ: string;
  VITE_APP_CHATWOOT_HMAC_KE: string;
  VITE_APP_CHATWOOT_HMAC_SI: string;
  VITE_APP_CHATWOOT_HMAC_KZ: string;
  VITE_APP_CHATWOOT_HMAC_IN: string;
  VITE_APP_CHATWOOT_HMAC_TR: string;
  VITE_APP_CHATWOOT_HMAC_MC: string;
  VITE_APP_CHATWOOT_HMAC_BN: string;
  VITE_APP_CHATWOOT_HMAC_AZ: string;
  VITE_APP_CHATWOOT_HMAC_NP: string;
  VITE_APP_CHATWOOT_HMAC_KR: string;
  VITE_APP_CHATWOOT_HMAC_PK: string;
  VITE_APP_CHATWOOT_TOKEN_HMAC_VN: string;
  VITE_APP_CHATWOOT_HMAC: string;
  VITE_APP_CHATWOOT_HMAC_BANGER: string;
  VITE_APP_CHATWOOT_HMAC_BANGER_BN: string;
  VITE_APP_CHATWOOT_HMAC_BANGER_IN: string;
  VITE_APP_CHATWOOT_HMAC_BANGER_FR: string;
  VITE_APP_CHATWOOT_HMAC_BANGER_GB: string;
  VITE_APP_CHATWOOT_TOKEN_HMAC_BANGER_VN: string;
  VITE_APP_ENV: string;
  VITE_APP_SOCKET_HOST: string;
  VITE_APP_VERSION_APP: string;
  VITE_APP_MAINTENCE_MODE: string;
  VITE_APP_PROJECT_NAME: string;
  VITE_APP_SUPPORT: string;
  VITE_APP_GAMES_VERSION: string;
};

export const env: EnvType = { ...import.meta.env, ...window.env };
